import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'gc-ld-correlation-pipe-provided-icon',
  imports: [SvgIconComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ld-correlation-pipe-provided-icon.component.html',
  styleUrl: './ld-correlation-pipe-provided-icon.component.scss',
})
export class LdCorrelationPipeProvidedIconComponent {
  public pipeProvided = input.required<boolean>();
}
